import React, { useRef } from "react";
import HeadingWithWatermark from "../HeadingWithWatermark";
import { Calendar, MapPin, Maximize2 } from "lucide-react";

const UpcomingEventCard = ({ image, title, date, location, file }) => {
  return (
  <div className="flex-shrink-0 w-[300px] md:w-[360px] lg:w-[400px] 
  bg-white/80 backdrop-blur-xl rounded-2xl shadow-md 
  hover:shadow-xl transition-all border border-gray-200 overflow-hidden">

  {/* Image */}
  <div className="h-52 overflow-hidden relative">
    <img
      src={image}
      alt={title}
      className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
    />

    <a
      href={image}
      target="_blank"
      className="absolute top-2 right-2 bg-black/60 p-2 rounded-full text-white hover:bg-black/80 transition"
    >
      <Maximize2 size={14} />
    </a>
  </div>

  {/* Content */}
  <div className="p-4 space-y-2">

    <h3 className="text-base font-semibold text-gray-900 leading-snug">
      {title}
    </h3>

    <div className="flex items-center text-sm text-gray-600 gap-2">
      <Calendar size={14} className="text-[#1b73a7]" />
      {date}
    </div>

    <div className="flex items-center text-sm text-gray-600 gap-2">
      <MapPin size={14} className="text-[#1b73a7]" />
      {location}
    </div>

    <a
      href={file}
      target="_blank"
      className="inline-block mt-2 px-5 py-1.5 rounded-md text-sm 
      text-white bg-[#1b73a7] hover:bg-[#155b87] transition"
    >
      Register
    </a>
  </div>
</div>

  );
};


const UpcomingEventsSection = () => {
  const scrollRef = useRef(null);

  const eventItems = [
    {
      image: "/img/2feb_event.png",
      title: "Global MSME Leadership Summit",
      date: "02 Feb 2026",
      location: "New Delhi, India",
      file: "/events/msme-summit.pdf",
    },
    {
      image: "/img/06_Feb_Event.jpeg",
      title: "AI for Small Businesses Webinar",
      date: "06 Feb 2026",
      location: "Virtual Event",
      file: "/events/ai-webinar.pdf",
    },
    {
      image: "/img/20_Feb_event.jpeg",
      title: "Export & Trade Finance Meet",
      date: "20 Feb 2026",
      location: "Mumbai, India",
      file: "/events/export-meet.pdf",
    },
    {
      image: "/img/24_April.jpeg",
      title: "Women Entrepreneurs Forum",
      date: "24 Apr 2026",
      location: "Paris, France",
      file: "/events/women-forum.pdf",
    },
    {
      image: "/img/26Feb_event.jpeg",
      title: "Startup & Innovation Expo",
      date: "26 Feb 2026",
      location: "Dubai, UAE",
      file: "/events/startup-expo.pdf",
    },
  ];

  const scroll = (dir) => {
    const amount = 420;
    scrollRef.current.scrollBy({
      left: dir === "left" ? -amount : amount,
      behavior: "smooth",
    });
  };

  return (
    <section className="py-8 bg-gradient-to-br from-[#f4f8fb] to-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">

        <HeadingWithWatermark
          title="Upcoming Events"
          watermarkText="WASME"
          color="#1b73a7"
          align="center"
        />

        {/* Controls */}
        <div className="flex justify-end gap-3 mt-1 mb-2">
          <button
            onClick={() => scroll("left")}
            className="w-10 h-10 rounded-full border border-gray-300 hover:bg-gray-100 transition"
          >
            ←
          </button>
          <button
            onClick={() => scroll("right")}
            className="w-10 h-10 rounded-full border border-gray-300 hover:bg-gray-100 transition"
          >
            →
          </button>
        </div>

        {/* Scroller */}
        <div
          ref={scrollRef}
          className="flex gap-8 overflow-x-auto no-scrollbar pb-4 cursor-grab"
        >
          {eventItems.map((event, i) => (
            <UpcomingEventCard key={i} {...event} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default UpcomingEventsSection;


